import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "../styles/classicSite.css";
import { CLASSIC_SITE_BASE } from "../classicSite.constants";
import {
  HOODIE_API_BASE_URL,
  isHoodieApiConfigured,
} from "../api/classicSiteHoodieApi";
import { hoodieConfigMessage } from "../classicSite.utils";
import { ClassicSiteSessionBadge } from "./MemberRouteGuard";

export default function ClassicSiteLayout() {
  const apiMessage = hoodieConfigMessage(
    isHoodieApiConfigured(),
    HOODIE_API_BASE_URL
  );

  return (
    <div className="cs-layout">
      <header className="cs-layout__header">
        <div className="cs-layout__brand">
          <NavLink to={CLASSIC_SITE_BASE} className="cs-layout__home-link">
            Classic Site (React silo)
          </NavLink>
          <span className="cs-layout__preview-tag">Preview — not production</span>
        </div>
        <p className="cs-layout__api-status">{apiMessage}</p>
        <ClassicSiteSessionBadge />
        <nav className="cs-layout__nav" aria-label="Classic site sections">
          <NavLink to={CLASSIC_SITE_BASE} end className="cs-nav-link">
            Home
          </NavLink>
          <NavLink to={`${CLASSIC_SITE_BASE}/public/listings`} className="cs-nav-link">
            Public listings
          </NavLink>
          <NavLink to={`${CLASSIC_SITE_BASE}/public/events`} className="cs-nav-link">
            Public events
          </NavLink>
          <NavLink to={`${CLASSIC_SITE_BASE}/public/promos`} className="cs-nav-link">
            Public promos
          </NavLink>
          <NavLink to={`${CLASSIC_SITE_BASE}/member`} className="cs-nav-link">
            Member
          </NavLink>
          <NavLink to={`${CLASSIC_SITE_BASE}/admin`} className="cs-nav-link">
            Admin parity
          </NavLink>
          <NavLink
            to={`${CLASSIC_SITE_BASE}/diagnostics/api-capabilities`}
            className="cs-nav-link"
          >
            API audit
          </NavLink>
          <NavLink
            to={`${CLASSIC_SITE_BASE}/diagnostics/staging-verification`}
            className="cs-nav-link"
          >
            Staging verify
          </NavLink>
        </nav>
      </header>
      <main className="cs-layout__main">
        <Outlet />
      </main>
      <footer className="cs-layout__footer">
        <p>
          Isolated under{" "}
          <code>{`${CLASSIC_SITE_BASE}/*`}</code>. Production member flows
          remain on Django <code>/member/*</code>.
        </p>
      </footer>
    </div>
  );
}
